import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import {
  formatDateTime,
  getCarTypes,
  getCorporateClientsBySeviceCityIdWithoutPagination,
  showAlert,
} from "../../Services/Shared.service";
import {
  createPackage,
  editPackageDetails,
  getPackage,
  getTaxGroupList,
} from "../../Services/Packages.service";
import moment from "moment";
import { addMonths, startOfMonth } from "date-fns";
import { ArrowDown, ArrowUp } from "react-feather";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { CommonModal } from "../../AbstractElements";

const PackageInput = ({ cityData, editId, isOpen, toggleModal,isExt }) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
      isActive: false,
      isKiosk: false,
      autoRollover: false,
      isAirportExpress: false,
      city: "",
      carTypeDropdown: "",
      baseFareTax: "",
      serviceTax: "",
      corporateClient: "",
      isAirportBooking: false,
      applicableFromDate: new Date(),
      applicableToDate: addMonths(new Date(), 1),
      thirdPartyClientId:"",
      serviceType:""
    },
  });

  const { isDriverPayout,overallTax } = watch();
  const values = getValues();
  const [carTypeData, setCarTypeData] = useState([]);
  const [corporateClientData, setCorporateClientData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [packageObj, setPackageObj] = useState({});
  const serviceTypeOptions = [
    { value: "ALL", label: "All" },
    { value: "A2C", label: "Airport To City" },
    { value: "C2A", label: "City To Airport" },
    { value: "C2C", label: "City To City" },
  ];

  const serviceTypeMap = {
    A2C: "AirportToCity",
    C2A: "CityToAirport",
    C2C: "CityToCity",
    ALL: "All",
  };
    const cityField = useController({
      name: "city",
      control,
      rules: {
        required: {
          value: true,
          message: "City is Required",
        },
      },
    }).field;
    const serviceTypeField = useController({
    name: "serviceType",
    control,
    rules: {
      required: {
        value: true,
        message: "Service Type is Required",
      },
    },
  }).field;

  const handleServiceTypeChange = (data) => {
    serviceTypeField.onChange(data.value);
  };



  const handleCitySelectChange = (data) => {
    cityField.onChange(data.value);
  };

  const corporateClientField = useController({
    name: "corporateClient",
    control,
    rules: {
      // required: {
      //     value: true,
      //     message: "Corporate Client is Required",
      // },
    },
  }).field;

  const handleCorporateClientSelectChange = (data) => {
    corporateClientField.onChange(data.value);
  };

  const applicableToDateField = useController({
    name: "applicableToDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable To Date is Required",
      },
    },
  }).field;

  const handleApplicableToDate = (data) => {
    applicableToDateField.onChange(data);
  };

  const applicableFromDateField = useController({
    name: "applicableFromDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable From Date is Required",
      },
    },
  }).field;

  const handleApplicableFromDate = (data) => {
    applicableFromDateField.onChange(data);
  };

  const carTypeField = useController({
    name: "carTypeDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Car type is Required",
      },
    },
  }).field;

  const handleCarTypeSelectChange = (data) => {
    carTypeField.onChange(data.value);
  };

  const isActiveField = useController({
    name: "isActive",
    control,
  }).field;

  const isKioskField = useController({
    name: "isKiosk",
    control,
  }).field;

  const autoRolloverField = useController({
    name: "autoRollover",
    control,
  }).field;

  const isAirportExpressField = useController({
    name: "isAirportExpress",
    control,
  }).field;

  const baseFareTaxField = useController({
    name: "baseFareTax",
    control,
    rules: {
      required: {
        value: true,
        message: "Base Fare Tax is Required",
      },
    },
  }).field;

  const handleBaseFareTax = (data) => {
    baseFareTaxField.onChange(data.value);
  };

  const serviceTaxField = useController({
    name: "serviceTax",
    control,
    rules: {
      required: {
        value: true,
        message: "Service Tax is Required",
      },
    },
  }).field;

  const handleServiceFareTax = (data) => {
    serviceTaxField.onChange(data.value);
  };

  useEffect(() => {
    setCorporateClientData([]);
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let obj = {
      serviceCityId,
      // travelType: isAirportExpressField.value ? "A2C" : "C2A",
    };
    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });
  }, [isAirportExpressField.value]);

  useEffect(() => {
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let obj = {
      serviceCityId,
      // travelType: isAirportExpressField.value ? "A2C" : "C2A",
    };
    getCarTypes(obj)
      .then((result) => {
        const data = result.data.map((element) => {
          return {
            label: element.name,
            value: element,
          };
        });
        setCarTypeData(data);
      })
      .catch((err) => {
        showAlert("error", "Unable to fetch Car details for selected City");
      });

    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });
  }, [cityField.value]);

  useEffect(() => {
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
        const data = result.data.map((element) => {
          return {
            value: element,
            label: element.name,
          };
        });
        setTaxData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (editId) {
      getPackage({ packageId: editId })
        .then((result) => {
          setPackageObj(result.data);
          const serviceCity = cityData.find((element) => {
            return element?.value?.id === result.data?.serviceCityId;
          });
          reset({
            name: result.data?.name ? result.data?.name : "",
            description: result.data?.description
              ? result.data?.description
              : "",
            isActive: result.data?.isActive ? result.data?.isActive : false,
            isKiosk: result.data?.isKiosk ? result.data?.isKiosk : false,
            autoRollover: result.data?.autoRollover
              ? result.data?.autoRollover
              : false,
            isAirportExpress: result.data?.isAirportExpress
              ? result.data?.isAirportExpress
              : false,
            city: result.data?.serviceCityId
              ? { id: serviceCity.value.id, name: serviceCity.value.name }
              : "",
            carTypeDropdown: result.data?.carTypeId
              ? { id: result.data?.carTypeId }
              : "",
            baseFareTax: result.data?.baseFareTaxId
              ? {
                  id: result.data?.baseFareTaxId,
                  name: result.data?.baseFareTaxName,
                }
              : "",
            serviceTax: result.data?.serviceTaxId
              ? {
                  id: result.data?.serviceTaxId,
                  name: result.data?.serviceTaxName,
                }
              : "",
            corporateClient: result.data?.corporateClientId
              ? {
                  id: result.data?.corporateClientId,
                  name: result.data?.corporateClientName,
                }
              : null,
              thirdPartyClientId:result?.data?.thirdPartyClientId?result?.data?.thirdPartyClientId:null,
              serviceType: result.data?.serviceType ? result.data?.serviceType : "",
            isAirportBooking: result.data?.isAirportBooking
              ? result.data?.isAirportBooking
              : false,
            applicableFromDate: result.data?.applicableFromDate
              ? new Date(result.data?.applicableFromDate)
              : "",
            applicableToDate: result.data?.applicableToDate
              ? new Date(result.data?.applicableToDate)
              : "",
              isDriverPayout: result.data?.isDriverPayout ? result.data?.isDriverPayout : false,
              initialDistanceKm: result.data?.initialDistanceKm ? result.data?.initialDistanceKm : null,
              perKmCharge:result.data.perKmCharge?result.data.perKmCharge:null,
              initialDistanceCharge:result.data.initialDistanceCharge?result.data.initialDistanceCharge:null,
              tollAmount:result.data.tollAmount?result.data.tollAmount:null,
          });
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  }, [editId]);

  const onFormSubmit = (formValues) => {
    setIsSubmitting(true);
    console.log("form values", formValues);
    const body = {
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
      isKiosk: formValues.isKiosk,
      autoRollover: formValues.autoRollover,
      isAirportExpress: formValues.isAirportExpress,
      isAirportBooking: formValues.isAirportBooking,
      serviceCityId: formValues.city.id,
      serviceCityName: formValues.city.name,
      baseFareTaxId: formValues.baseFareTax.id,
      baseFareTaxName: formValues.baseFareTax.name,
      serviceTaxId: formValues.serviceTax.id,
      serviceTaxName: formValues.serviceTax.name,
      corporateClientId: formValues.corporateClient?.id
        ? formValues.corporateClient.id
        : null,
      applicableFromDate: new Date(formValues.applicableFromDate),
      applicableToDate: new Date(formValues.applicableToDate),
      carTypeId: formValues.carTypeDropdown.id,
      isDriverPayout:formValues.isDriverPayout?formValues.isDriverPayout:false,
      initialDistanceKm:formValues.initialDistanceKm?formValues.initialDistanceKm:null,
      perKmCharge:formValues.perKmCharge?formValues.perKmCharge:null,
      initialDistanceCharge:formValues.initialDistanceCharge?formValues.initialDistanceCharge:null,
      tollAmount:formValues.tollAmount?formValues.tollAmount:null,
      serviceType: serviceTypeMap[formValues.serviceType] || formValues.serviceType,
    };
    createPackage(body)
      .then((result) => {
        reset({
          name: "",
          description: "",
          isActive: false,
          isKiosk: false,
          autoRollover: false,
          isAirportExpress: false,
          city: "",
          carTypeDropdown: "",
          baseFareTax: "",
          serviceTax: "",
          corporateClient: "",
          isAirportBooking: false,
          applicableFromDate: "",
          applicableToDate: "",
        });
        showAlert("success", "Package Created Successfully");
        setIsSubmitting(false);
        toggleModal();
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
        setIsSubmitting(false);
      });
  };

  const onEditSubmit = (formValues) => {
    console.log("edit values", formValues);
    setIsSubmitting(true);
    const body = {
      id: packageObj?.id,
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
      isKiosk: formValues.isKiosk,
      autoRollover: formValues.autoRollover,
      isAirportExpress: formValues.isAirportExpress,
      isAirportBooking: formValues.isAirportBooking,
      serviceCityId: formValues.city.id,
      serviceCityName: formValues.city.name,
      baseFareTaxId: formValues.baseFareTax.id,
      baseFareTaxName: formValues.baseFareTax.name,
      serviceTaxId: formValues.serviceTax.id,
      serviceTaxName: formValues.serviceTax.name,
      corporateClientId: formValues.corporateClient?.id ? formValues.corporateClient.id : null,
      applicableFromDate: new Date(formValues.applicableFromDate),
      applicableToDate: new Date(formValues.applicableToDate),
      carTypeId: formValues.carTypeDropdown.id,
      isDriverPayout: formValues.isDriverPayout? formValues.isDriverPayout : false,
      initialDistanceKm: formValues.initialDistanceKm ? formValues.initialDistanceKm : null,
      perKmCharge:formValues.perKmCharge?formValues.perKmCharge:null,
      initialDistanceCharge:formValues.initialDistanceCharge?formValues.initialDistanceCharge:null,
      tollAmount:formValues.tollAmount?formValues.tollAmount:null,
      thirdPartyClientId:formValues?.thirdPartyClientId?formValues?.thirdPartyClientId:null,
      serviceType: serviceTypeMap[formValues.serviceType] || formValues.serviceType,
    };
    editPackageDetails(body)
      .then((result) => {
        // reset({
        //     name: '',
        //     description: '',
        //     isActive: false,
        //     isKiosk: false,
        //     autoRollover: false,
        //     isAirportExpress: false,
        //     city: '',
        //     carTypeDropdown: '',
        //     baseFareTax: '',
        //     serviceTax: '',
        //     corporateClient: '',
        //     isAirportBooking: false,
        //     applicableFromDate: '',
        //     applicableToDate: ''
        // })
        showAlert("success", "Package Updated Successfully");
        // setPackageObj({})
        toggleModal();
        setIsSubmitting(false);
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
        setIsSubmitting(false);
      });
  };

  return (
    <CommonModal
      isOpen={isOpen}
      title={editId ? "Edit Package" : "Create Package"}
      toggler={() => {
        // reset({
        //     name: '',
        //     description: '',
        //     isActive: false,
        //     isKiosk: false,
        //     autoRollover: false,
        //     isAirportExpress: false,
        //     city: '',
        //     carTypeDropdown: '',
        //     baseFareTax: '',
        //     serviceTax: '',
        //     corporateClient: '',
        //     isAirportBooking: false,
        //     applicableFromDate: '',
        //     applicableToDate: ''
        // })
        // setPackageObj({})
        toggleModal();
      }}
      size="xl"
    >
      <Form
        onSubmit={handleSubmit(packageObj?.id ? onEditSubmit : onFormSubmit)}
      >
        <Row>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Name</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("name", {
                  required: {
                    value: true,
                    message: "Name is required",
                  },
                  onChange: (e) => {
                    setValue("name", e.target.value.trimStart());
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.name?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Service City</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    cityField?.value?.id
                      ? cityData.find((element) => {
                          return element?.value?.id === cityField?.value?.id;
                        })
                      : ""
                  }
                  isDisabled={packageObj?.id ? true : false}
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleCitySelectChange}
                  placeholder="Select City"
                  options={cityData}
                />
              </div>
              <span style={{ color: "red" }}>{errors?.city?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Service Type</Label>
            <Col lg="12">
              <Select
                value={serviceTypeField.value}
                onChange={handleServiceTypeChange}
                options={serviceTypeOptions}
                placeholder="Select Service Type"
              />
              <span style={{ color: "red" }}>
                {errors?.serviceType?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Corporate Client</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={true}
                  value={
                    corporateClientField?.value?.id
                      ? corporateClientData.find((element) => {
                          return (
                            element?.value?.id ===
                            corporateClientField?.value?.id
                          );
                        })
                      : ""
                  }
                  isDisabled={cityField?.value?.id ? false : true}
                  // defaultValue={cityData.find((element) => {
                  //     return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleCorporateClientSelectChange}
                  placeholder={
                    cityField?.value?.id
                      ? "Select Corporate Client"
                      : "Select city to select corporate client"
                  }
                  options={corporateClientData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.corporateClient?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Car Type</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    carTypeField?.value?.id
                      ? carTypeData.find((element) => {
                          return element?.value?.id === carTypeField?.value?.id;
                        })
                      : ""
                  }
                  isDisabled={cityField?.value?.id ? false : true}
                  onChange={handleCarTypeSelectChange}
                  placeholder={
                    cityField?.value?.id
                      ? "Select Car Type"
                      : "Select city to select car type"
                  }
                  options={carTypeData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.carTypeDropdown?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Base Fare Tax</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    baseFareTaxField?.value?.id
                      ? taxData.find((element) => {
                          return (
                            element?.value?.id === baseFareTaxField?.value?.id
                          );
                        })
                      : ""
                  }
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handleBaseFareTax}
                  placeholder="Select Base Fare Tax"
                  options={taxData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.baseFareTax?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Service Tax</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    serviceTaxField?.value?.id
                      ? taxData.find((element) => {
                          return (
                            element?.value?.id === serviceTaxField?.value?.id
                          );
                        })
                      : ""
                  }
                  //   // defaultValue={cityData.find((element) => {
                  //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   //   return element?.value?.id === cityField?.value?.id;
                  //   // })}
                  onChange={handleServiceFareTax}
                  placeholder="Select Service Tax"
                  options={taxData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.serviceTax?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup
            className="col-lg-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="IsActive"
                type="checkbox"
                checked={isActiveField.value}
                onChange={(value) => isActiveField.onChange(value)}
              />
              <Label className="mb-0" for="IsActive">
                {"Available {Yes/No}"}
              </Label>
            </div>
          </FormGroup>
          <FormGroup
            className="col-lg-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="IsKiosk"
                type="checkbox"
                checked={isKioskField.value}
                onChange={(value) => isKioskField.onChange(value)}
              />
              <Label className="mb-0" for="IsKiosk">
                {"Is Kiosk"}
              </Label>
            </div>
          </FormGroup>

          <FormGroup
              className="col-lg-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                className={
                  mix_background_layout == "dark-only"
                    ? "checkbox-dark p-0"
                    : "checkbox p-0"
                }
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                  id="isDriverPayout"
                  type="checkbox"
                  {...register("isDriverPayout", {})}
                />
                <Label className="mb-0" for="isDriverPayout">
                  {"IsDriverPayout"}
                </Label>
              </div>
            </FormGroup>

        </Row>


        {isDriverPayout ? (
          <Row>
            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                InitialDistanceKm
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("initialDistanceKm", {
                    required: {
                      value: isDriverPayout,
                      message: "InitialDistanceKm is required",
                    },
                    onChange: (e) => {
                      setValue("initialDistanceKm", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.initialDistanceKm?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">
                InitialDistanceCharge
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("initialDistanceCharge", {
                    required: {
                      value: isDriverPayout,
                      message: "InitialDistanceCharge is required",
                    },
                    onChange: (e) => {
                      setValue(
                        "initialDistanceCharge",
                        e.target.value.trimStart()
                      );
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.initialDistanceCharge?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">PerKmCharge</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  key={false}
                  {...register("perKmCharge", {
                    required: {
                      value: isDriverPayout,
                      message: "perKmCharge is required",
                    },
                    onChange: (e) => {
                      setValue("perKmCharge", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.perKmCharge?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-3">
              <Label className="col-lg-12 col-form-label">Toll Amount</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="number"
                  key={false}
                  {...register("tollAmount", {
                    required: {
                      value: isDriverPayout,
                      message: "TollAmount is required",
                    },
                    onChange: (e) => {
                      setValue("tollAmount", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.tollAmount?.message}
                </span>
              </Col>
            </FormGroup>
          </Row>
        ) : null}
        <Row>
          <div
            style={{
              color: "#11BF5C",
              textDecoration: "underline",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setIsAdvanced(!isAdvanced)}
          >
            Advanced Configurations{" "}
            {isAdvanced ? (
              <ArrowUp
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            ) : (
              <ArrowDown
                style={{ width: "15px", height: "15px", marginLeft: "5px" }}
              />
            )}
          </div>
        </Row>

        {isAdvanced ? (
          <Row>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Description</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("description", {
                    onChange: (e) => {
                      setValue("description", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.description?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Available From</Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableFromDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableFromDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableFromDate?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Available To</Label>
              <Col lg="12">
                <InputGroup
                  className="date"
                  id="dt-minimum"
                  data-target-input="nearest"
                >
                  <DatePicker
                    className="form-control datetimepicker-input digits"
                    selected={applicableToDateField.value}
                    showTimeSelect
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    onChange={handleApplicableToDate}
                    dateFormat="MMMM d yyyy, h:mm:ss a"
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {errors?.applicableToDate?.message}
                </span>
              </Col>
            </FormGroup>
          </Row>
        ) : null}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="submit"
            className="btn submit-button"
            disabled={isSubmitting}
          >
            {packageObj?.id ? "Update" : "Create"}
          </button>
        </div>
      </Form>
    </CommonModal>
  );
};

export default PackageInput;
